import { Campaign } from "@vviinn/user-managment-client-ts";
import { useParams } from "react-router";

import { FC } from "react";
import { DetailKeynote } from "../../../components/GeneralUI/DetailedCardComponents";
import { useAppSelector } from "../../../store";

import { allTextTitles, keyWithType, NetKey } from "../../../helpers";
import {
  netRootTitles,
  textCampaignWeightsKeys,
} from "../../textSearch/constants";
import { typecastedTextSearch } from "../../textSearch/typecastedTextSearch";
import { TextSearchNumbericTitlesKey } from "../../textSearch/types";
import { getReferenceSiteName } from "../../helpers/getReferenceSiteName";

const pushKeynote = (title: NetKey, value: string, nets: string[]) => {
  const relevantTitle = allTextTitles[title];
  nets.push(`${relevantTitle}: ${value}`);
};

const setNetsKeynotes = (campaign: Campaign) => {
  const nets: string[] = [];
  if (campaign.type === "TEXT_SEARCH") {
    for (const key in textCampaignWeightsKeys) {
      const { typecastedKey, value } = typecastedTextSearch(
        key as TextSearchNumbericTitlesKey,
        campaign,
      );
      if (value) pushKeynote(netRootTitles[typecastedKey], `${value}`, nets);
    }
  }

  Object.keys(allTextTitles).forEach((title) => {
    const campaignNetKey = keyWithType<keyof Campaign>(title, "", "Weight");
    const value = campaign[campaignNetKey];
    if (value) pushKeynote(title, `${value}`, nets);
  });
  return nets;
};

export const CampaignKeynote: FC<{ campaign: Campaign }> = ({ campaign }) => {
  const { companyId } = useParams();
  const { accessibleCompanies, referenceSiteId } = useAppSelector(
    (state) => state.sites,
  );
  const referenceSiteIdValue = referenceSiteId?.referenceSiteId;

  const keynoteItems: string[] = [];

  if (campaign.type === "VPD") {
    const referenceSiteName = getReferenceSiteName(
      campaign,
      accessibleCompanies,
      companyId,
      referenceSiteIdValue,
    );
    keynoteItems.push(referenceSiteName);
  } else {
    keynoteItems.push(...setNetsKeynotes(campaign));
  }
  return <DetailKeynote items={keynoteItems} noItemsMessage="No active Nets" />;
};
